module.exports = __webpack_public_path__ + "docs/img/android-chrome-256x256.0ebb373a.png";